import { Box, Heading, Grid, GridItem, IconButton } from '@chakra-ui/react'
import BaseLayout from '@Common/Layouts/BaseLayout'
import { withLoader } from '@Common/Utils/HOF'
import config from '@Config'
import DomainInfo from '@Domains/Components/DomainInfo'
import DomainStatus from '@Domains/Components/DomainStatus'
import { useDomainQuery, useTakeDomainScreenshotMutation } from '@Domains/Services/Api'
import { IoRefresh } from 'react-icons/io5'
import { toast } from '@Common/Components/Toast'
import { responseTextError } from '@Common/Utils/Api'
import Logger from '@Common/Utils/Logger'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'

const DomainDetailView = () => {
  const { t } = useTranslation()
  const params = useParams()
  const [takeScreenshot] = useTakeDomainScreenshotMutation()
  const { data: domain, isFetching } = useDomainQuery(params.domainId)

  const handleTakeScreenshot = async () => {
    try {
      await takeScreenshot(domain.id).unwrap(),
        toast({
          title: t(`domains:ui.TakeScreenshot`),
          description: t('ui.OperationStarted'),
          status: 'success',
          duration: 3000,
          isClosable: true,
        })
    } catch (err) {
      Logger.error(`Take domain screenshot error`, err)
      toast({
        title: t(`domains:ui.TakeScreenshot`),
        description: t('ui.OperationError', { error: responseTextError(err) }),
        status: 'error',
        duration: 10000,
        isClosable: true,
      })
    }
  }

  return (
    <BaseLayout>
      {withLoader(
        () => (
          <Box p="1.5rem">
            <Grid templateColumns="400px 1fr" gap={3}>
              <GridItem>
                <Heading mb="1rem">{domain.name}</Heading>
                <div
                  style={{
                    background: `url('${config.mediaBasePath + domain.screenshot}') no-repeat top left`,
                    backgroundSize: '100%',
                    width: '100%',
                    height: '200px',
                    marginBottom: '1rem',
                    position: 'relative',
                  }}
                >
                  <IconButton
                    onClick={handleTakeScreenshot}
                    isRound
                    style={{
                      borderRadius: '50%',
                      position: 'absolute',
                      top: '4px',
                      right: '4px',
                    }}
                  >
                    <IoRefresh />
                  </IconButton>
                </div>
                <DomainInfo domain={domain} />
              </GridItem>
              <GridItem>
                <DomainStatus domain={domain} />
              </GridItem>
            </Grid>
          </Box>
        ),
        isFetching,
      )}
    </BaseLayout>
  )
}

export default DomainDetailView
